import { Box, Divider, Grid, Typography, useMediaQuery, useTheme, withStyles } from "@material-ui/core";
import React from 'react'
import config from '../../_config/config'

const styles = theme => ({
    main: {
        width: '100%',
        height: 64,
        boxShadow: '0 3px 9px rgb(0 0 0 / 16%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#10252C',
        [theme.breakpoints.down('sm')]: {
            height: 128,
        }
    },
    contactsMain: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    contactContainer: {
        display: "flex",
        flexDirection: "row",
        // flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
    },
    contactImage: {
        height: 16,
    },
    itemDivider: {
        width: 20,
        height: "50%",
        [theme.breakpoints.down('sm')]: {
            backgroundColor: '#ccc',
            width: 1,
            marginLeft: 15,
            marginRight: 15,
        }
    },
    footerItem: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    footerItemText: {
        fontSize: 10,
        color: "white",
    },
    footerMainText: {
        fontSize: 10,
        color: "white",
        alignSelf: "center",
        marginTop: 10,
    },
});

function _Footer({ classes }) {
    const theme = useTheme();
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const matchesXs = useMediaQuery(theme.breakpoints.down('xs'));

    const FooterItem = (props) => {
        const { image, text, color, link } = props;
        return (
            <Box className={classes.footerItem} onClick={() => {
                window.open(link || config.contentendpoint, "_blank")
            }}>
                <img
                    style={{
                        maxHeight: matchesSm && matchesXs ? 24 : 16,
                        // margin: '8px 12px 8px 0px'
                        margin: 8,
                        marginLeft: 0
                    }}
                    src={image}
                    alt="footer logo image"
                />
                <Typography className={classes.footerItemText} style={{ color: color || 'white' }}>
                    {text}
                </Typography>
            </Box>
        )
    }

    return (
        <Box className={classes.main}>
            <Typography className={classes.footerMainText}>
                {'Tradebulls Platforms'}
            </Typography>
            {!matchesSm && !matchesXs ? <Box className={classes.contactsMain}>
                <FooterItem
                    image={"../images/net.svg"}
                    color={'#4AB9E5'}
                    text={'Tradebulls Pro'}
                    link={'https://www.tradebulls.in/trading-platform#tradebulls-net'} />
                <Divider className={classes.itemDivider} />
                <FooterItem
                    image={"../images/touch.svg"}
                    color={'#98CB08'}
                    text={'Tradebulls Touch'}
                    link={'https://www.tradebulls.in/trading-platform#tradebulls-net'} />
                <Divider className={classes.itemDivider} />
                <FooterItem
                    image={"../images/iOS.svg"}
                    imageSize={3}
                    text={'App Store'}
                    link={'https://apps.apple.com/us/app/tradebulls-touch-2-0/id1577520443'} />
                <Divider className={classes.itemDivider} />
                <FooterItem
                    image={"../images/android.svg"}
                    imageSize={3}
                    text={'Google Play'}
                    link={'https://play.google.com/store/apps/details?id=in.tradebulls.trading'} />
            </Box> :
                <>
                    <Box className={classes.contactsMain}>
                        <FooterItem
                            image={"../images/net.svg"}
                            color={'#4AB9E5'}
                            text={'Tradebulls Pro'}
                            link={'https://www.tradebulls.in/trading-platform#tradebulls-net'} />
                        <Divider className={classes.itemDivider} />
                        <FooterItem
                            image={"../images/touch.svg"}
                            color={'#98CB08'}
                            text={'Tradebulls Touch'}
                            link={'https://www.tradebulls.in/trading-platform#tradebulls-net'} />
                    </Box>
                    <Box className={classes.contactsMain}>
                        <FooterItem
                            image={"../images/iOS.svg"}
                            imageSize={3}
                            text={'App Store'}
                            link={'https://apps.apple.com/us/app/tradebulls-touch-2-0/id1577520443'} />
                        <Divider className={classes.itemDivider} />
                        <FooterItem
                            image={"../images/android.svg"}
                            imageSize={3}
                            text={'Google Play'}
                            link={'https://play.google.com/store/apps/details?id=in.tradebulls.trading'} />
                    </Box>
                </>
            }
        </Box>
    )
}

export default withStyles(styles)(_Footer);
